
export default function getPriceSavingsInformation (listPrice, insightPrice, showDiscount) {
  // calculate price savings
  const priceSavings = Number(parseFloat(listPrice - insightPrice).toFixed(2));
  // calculate the percentage decrease of Your Price base on List Price
  const calculatePricePercentage = (priceSavings / listPrice) * 100;
  const showListPriceAndSavings = showDiscount || calculatePricePercentage > 5 || priceSavings > 10;

  return {
    priceSavings,
    showListPriceAndSavings,
    priceSavingsInPercentage: Number(calculatePricePercentage.toFixed(2))
  };
}
